import { render, staticRenderFns } from "./wxPayInfo.vue?vue&type=template&id=7d8cba88&scoped=true&"
import script from "./wxPayInfo.vue?vue&type=script&lang=js&"
export * from "./wxPayInfo.vue?vue&type=script&lang=js&"
import style0 from "./wxPayInfo.vue?vue&type=style&index=0&id=7d8cba88&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8cba88",
  null
  
)

export default component.exports